import { axios, handleError } from '../axios';

export const getGPosts = (category, pageNumber, deletedPostCount) => {
  return new Promise((resolve) => {
    axios
      .get('posts/', {
        params: {
          gc: category,
          pn: pageNumber,
          s: deletedPostCount,
        },
      })
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
